var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('save-as-favorite-button',{attrs:{"subject-ref":_vm.championshipRef,"save":_vm.save,"remove":_vm.remove}})
}
var staticRenderFns = []

export { render, staticRenderFns }